import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden grain">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1526506118085-60ce8714f8c5"
          alt="Athlete training"
          className="w-full h-full object-cover grayscale"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/70 via-[#0A0A0A]/60 to-[#0A0A0A]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-28 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-flex items-center gap-2 text-xs sm:text-sm uppercase tracking-[0.25em] text-[#0055FF] font-bold mb-6">
            <span className="h-px w-8 bg-[#0055FF]" /> Online Transformation Coaching
          </span>
        </motion.div>

        <motion.h1
          data-testid="hero-headline"
          className="font-display font-bold uppercase tracking-tighter text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] max-w-4xl"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          Become The<br />
          Strongest<br />
          <span className="text-[#0055FF]">Version</span> Of Yourself.
        </motion.h1>

        <motion.p
          className="mt-8 text-base sm:text-lg text-[#A3A3A3] max-w-xl leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          Helping real people lose fat, build muscle, gain confidence, and build
          discipline through customized coaching and accountability.
        </motion.p>

        <motion.div
          className="mt-10 flex flex-col sm:flex-row gap-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.45 }}
        >
          <button
            data-testid="hero-apply-button"
            onClick={() => scrollTo("apply")}
            className="group inline-flex items-center justify-center gap-2 bg-[#0055FF] text-white hover:bg-[#3377FF] transition-colors font-bold px-8 py-4 uppercase tracking-wide"
          >
            Apply For Coaching
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid="hero-programs-button"
            onClick={() => scrollTo("programs")}
            className="inline-flex items-center justify-center bg-transparent border border-[#262626] text-white hover:border-[#0055FF] transition-colors font-bold px-8 py-4 uppercase tracking-wide"
          >
            View Programs
          </button>
        </motion.div>

        <motion.div
          className="mt-16 flex flex-wrap gap-8 sm:gap-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          {[
            { n: "100LBS", l: "Personal Transformation" },
            { n: "5+ YRS", l: "Training Experience" },
            { n: "WORLDWIDE", l: "Online Coaching" },
          ].map((s) => (
            <div key={s.l}>
              <div className="font-display font-bold text-2xl sm:text-3xl text-white">{s.n}</div>
              <div className="text-xs uppercase tracking-widest text-[#A3A3A3] mt-1">{s.l}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
